<template>
	<div class="floatTip" @mouseleave="mouseActive = -1">
		<div class="floatTip_img" v-for="(item,index) in imgList" :key="index" @click="navToLink(item.link)"
			@mouseenter="setFloatShow(index)">
			<img :src="mouseActive == index ?item.activePath:item.noramlPath" alt="">
			<p>{{item.name}}</p>
		</div>
		<div class="left_float" :style="{top:showTop +'px'}" v-show="mouseActive == 0">
			<div class="float_Head">
				<p>公众号</p>
			</div>
			<div class="float_body">
				<img :src=basicInfo.qr_code alt="" srcset="">
			</div>
		</div>
		<div class="left_float" :style="{top:showTop +'px'}" v-show="mouseActive == 1">
			<div class="float_Head">
				<p>咨询电话</p>
			</div>
			<div class="float_body">
				<p>{{basicInfo.cellphone}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getBasicInfo
	} from "../api/moudles/user";

	export default {
		data() {
			return {
				showTop: 0,
				mouseActive: -1,
				basicInfo: {},
				imgList: [{
					name: '公众号',
					noramlPath: require('../assets/img/school/gzh-grey.png'),
					activePath: require('../assets/img/school/gzh-blue.png'),
					link: ''
				}, {
					name: '咨询电话',
					noramlPath: require('../assets/img/school/phone-grey.png'),
					activePath: require('../assets/img/school/phone-blue.png'),
					link: ''
				}

         /* {
          name: '诚邀评价',
          noramlPath: require('../assets/img/school/pingjia1.png'),
          activePath: require('../assets/img/school/pingjia2.png'),
          link: 'http://wj.newgrand.cn/vm/Q0mWfWU.aspx'
          }*/
				]
			}
		},
		created() {
			this.getBasicInfo()
		},
		methods: {
			// 跳转地址
			navToLink(link) {
				if (link) {
					window.open(link)
				}
			},
			setFloatShow(index) {
				const setTop = document.querySelectorAll('.floatTip_img')[index]
				console.log('setTop', setTop.offsetTop)
				this.showTop = setTop.offsetTop
				this.mouseActive = index
			},
			// 获取基本信息
			async getBasicInfo() {
				await getBasicInfo({
					data: {
						column_code: '5F8B3D07-841C-E204-58D9-3FF4BCEE4765'
					},
					success: res => {
						this.basicInfo = res.data
					}
				})
			},
		}
	}
</script>

<style scoped>
	.floatTip {
		position: fixed;
		top: 45vh;
		right: 10px;
		height: 200px;
		width: 100px;
		background: #FCFDFF;
		border: 1px solid rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.1);
		border-radius: 8px;
		display: flex;
		flex-flow: column;
	}

	.floatTip_img {
		flex: 1;
		display: flex;
		flex-flow: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.floatTip_img img {
		width: 30px;
		height: 25px;
	}

	.floatTip_img p {
		margin-top: 10px;
	}

	.left_float {
		overflow: hidden;
		min-width: 150px;
		position: absolute;
		right: 110px;
		min-height: 100px;
		border-radius: 8px;
		background: #FCFDFF;
		box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.1);
	}

	.float_Head {
		width: 100%;
		height: 35px;
		line-height: 35px;
		font-size: 16px;
		padding-left: 10px;
		box-sizing: border-box;
		background-color: #F2f4f6;
	}

	.float_body {
		padding: 10px 10px;
		width: 150px;
		height: auto;
	}

	.float_body img {
		width: 100%;
		height: 100%;
	}
</style>
